/**
 * Created by mac on 12/23/20
 */

const Grounded = function (unit) {
    UnitComponent.call(this, unit);
};

Grounded.prototype = Object.create(UnitComponent.prototype);
Grounded.prototype.constructor = Grounded;

Grounded.prototype.save = function (data) {
    data.grounded = 1;
};

Grounded.prototype.isMovable = function () {
    return false;
};

Grounded.prototype.isMergeable = function () {
    return this.isOpened();
};

Grounded.prototype.isOpened = function () {
    return this.state === Grounded.STATE.GROUNDED;
};

Grounded.prototype.onRemove = function (silent) {
    if (this.view) {
        this.view.removeStates(silent);
    }
};

Grounded.prototype.onStartMergeHint = function () {
    if (this.view) {
        this.view.onStartMergeHint();
    }
};

Grounded.prototype.onStopMergeHint = function () {
    if (this.view) {
        this.view.onStopMergeHint();
    }
};

Grounded.prototype.canSmile = function () {
    if (this.view) {
        return this.view.canSmile();
    }
};

Grounded.prototype.smile = function () {
    if (this.view) {
        this.view.smile();
    }
};

Grounded.prototype.handleRemove = function () {
    this.onRemove();

    Merge2.current.field.iterateNeighbours(this.unit.x, this.unit.y, (cell) => {
        const unit = Merge2.current.field.getUnit(cell.x, cell.y);
        const grounded = unit && unit.findComponent(Grounded);
        if (grounded) {
            grounded.updateState();
        }
    });
};

Grounded.prototype.updateState = function () {
    let state = Grounded.STATE.FOG;

    Merge2.current.field.iterateNeighbours(this.unit.x, this.unit.y, (cell) => {
        if (Merge2.current.field.isValid(cell.x, cell.y)) {
            const neighbor = Merge2.current.field.getUnit(cell.x, cell.y);
            if (!neighbor || !neighbor.findComponent(Grounded)) {
                state = Grounded.STATE.GROUNDED;
            }
        }
    });

    if (state !== this.state) {
        const wasFog = this.state === Grounded.STATE.FOG;

        this.state = state;
        this.onUpdateState();

        if (wasFog && this.isOpened()) {
            const fieldReward = this.unit.findComponent(FieldReward);
            if (fieldReward) {
                fieldReward.open();
            }
        }
    }
};

Grounded.prototype.onUpdateState = function () {
    if (this.view) {
        this.view.restoreState();
    }
};

Grounded.STATE = {};
Grounded.STATE.FOG = "fog";
Grounded.STATE.GROUNDED = "grounded";